import { layoutEvents } from '@libs/analytics';

export function trackingData(data: object) {
    return Object.assign(data, { ...layoutEvents.headerMenuNavClick });
}
